export function getId(data: Record<'id', string> & Record<string, unknown>): string {
  return data.id;
}
